export default __webpack_public_path__ + "static/media/tooltipaccountsetup.eb0ed4f0.svg";